import {observable, computed} from 'mobx';
import {isEmpty} from 'lodash';
import {forEach, concat, get} from 'lodash';

export type RightBarSectionType = 'lib' | 'msg' | 'image' | 'video' | 'hist' | 'wifiScan' | 'visualScan';

export interface MessageData {
    type: string;
    sender: string;
    isNew?: boolean;
    message: string;
    storageIndex?: string;
    [key: string]: any;
}

export class RightBarState {
    // Section open/closed states - centralized in one place
    @observable libSectionOpen: boolean = false;
    @observable msgSectionOpen: boolean = false;
    @observable imageSectionOpen: boolean = false;
    @observable videoSectionOpen: boolean = false;
    @observable histSectionOpen: boolean = false;
    @observable wifiScanSectionOpen: boolean = false;
    @observable visualScanSectionOpen: boolean = false;
    @observable expandRightBar: boolean = false;

    // History related
    @observable customerHistory: any = null;
    @observable enableHistory: boolean = false;
    @observable hideHistory: boolean = false;

    // Library and tagging
    @observable libraryTaggingMode: boolean = false;

    // Sharing
    @observable resourcesReadyToBeShared: boolean = false;
    @observable selectedResourcesCount: {images: number; history: number} = {images: 0, history: 0};
    @observable sharingModeActions: any[] = [];

    // Interaction summaries
    @observable interactionSummaryPreviews: any[] = [];

    // Settings
    @observable dateFormat: string = '';
    @observable allowUploadImageFileFromDashboard: boolean = false;

    // Feature flags (read-only after initialization)
    @observable libraryEnabled: boolean = true;
    @observable allowMessages: boolean = true;
    @observable allowPredefined: boolean = false;

    // Messages/chat data
    @observable meetingHistory: MessageData[] = [];

    @computed
    get flattenedHistoryRecords(): any[] {
        let records: any[] = [];
        forEach(get(this.customerHistory, 'records'), (record: any) => {
            records = concat(records, get(record, 'images'));
        });
        return records;
    }

    @computed
    get historyEmpty(): boolean {
        if (!this.customerHistory) {
            return true;
        }
        return isEmpty(get(this.customerHistory, 'records'));
    }

    @computed
    get meetingHistoryLength(): number {
        return this.meetingHistory.length;
    }

    @computed
    get textMessages(): MessageData[] {
        return this.meetingHistory.filter((m) => m.type === 'text');
    }
}
